import * as React from 'react'

function SvgPointUnchecked(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M10.586 12 7.293 8.708l1.414-1.415L12 10.586l3.293-3.293 1.414 1.414L13.414 12l3.293 3.292-1.414 1.415h-.001v-.002L12 13.415l-3.292 3.292-1.415-1.414L10.586 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgPointUnchecked
